import clsx from "clsx";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import style from "./style.module.scss";

export const Loading = ({ classNames, isTextPrinted = true }) => {
  const [activeDotIndex, setActiveDotIndex] = useState(0);
  const ref = useRef();
  // React i18next
  const { t } = useTranslation();

  // Animation
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveDotIndex((c) => (c === 3 ? 1 : c + 1));
    }, 400);

    return () => clearTimeout(interval);
  }, []);

  return (
    <div ref={ref} className={clsx(style.block, classNames)}>
      <div className={style.dots}>
        <span className={activeDotIndex === 1 ? style.activeDot : undefined} />
        <span className={activeDotIndex === 2 ? style.activeDot : undefined} />
        <span className={activeDotIndex === 3 ? style.activeDot : undefined} />
      </div>
      {isTextPrinted && <div className={style.text}>{t("Loading")}...</div>}
    </div>
  );
};

export default Loading;
